import * as React from 'react';
import { useState } from 'react';
import { withStyles } from '@material-ui/core';
import DataGrid from '@dataGrid';
import GridHeader from './GridHeader';
import { CommonGridOwnProps } from './IGridWithHeader';

const styles = (theme: any) => ({
  gridContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column' as const,
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 5,
  },
  dataGrid: {
    flex: 1,
    boxSizing: 'border-box' as const,
    height: '100%',
    minHeight: '200px',
    maxHeight: '100%',
    '& .ag-theme-material .ag-body-horizontal-scroll': {
      borderWidth: '0px'
    },
    [`&>.gridTheme-${theme.themeName}>.ag-theme-material.theme-${theme.themeName}`]: {
      height: '100%'
    },
    '& .ag-center-cols-viewport': {
      width: `calc(100% + 18px)`
    },
    '& .statusBar': {
      display: 'block'
    }
  }
});


interface CommonGridInjectedProps {
  classes: any;
}

type CommonGridProps<T> = CommonGridOwnProps<T> & CommonGridInjectedProps;

function CommonGridComponent<T = any>({
  classes,
  title,
  exportFileName,
  data,
  config,
  onToggleGridMaximize,
  onRowsSelected,
  isVisible = true,
  gridHeaderConfig,
}: CommonGridProps<T>) {
  const [gridApi, setGridApi] = useState<any>(null);
  const [searchText, setSearchText] = useState('');

  const onGridReady = (params: any) => {
    setGridApi(params.api);
  };

  const onSelectionChanged = () => {
    if (!onRowsSelected) return;
    const selected = gridApi?.getSelectedRows?.() ?? [];
    onRowsSelected(selected);
  };

  const onSearchTextChange = (text: string) => {
    setSearchText(text);
  };

  return (
    <div className={classes.gridContainer} style={{ display: isVisible ? 'flex' : 'none' }}>
      <GridHeader
        title={title}
        onSearchTextChange={onSearchTextChange}
        gridApi={gridApi}
        exportFileName={exportFileName}
        onToggleGridMaximize={onToggleGridMaximize}
        gridHeaderConfig={gridHeaderConfig}
      />
      <div className={classes.dataGrid}>
        <DataGrid
          columnDefs={config.columns}
          config={config}
          defaultColDef={config.defaultColDef}
          rowSelection={config.rowSelection}
          rowDeselection={config.rowDeselection}
          rowData={data}
          onGridReady={onGridReady}
          onSelectionChanged={onSelectionChanged}
          quickFilterText={searchText}
        />
      </div>
    </div>
  );
}

const CommonGrid = withStyles(styles)(
  CommonGridComponent as React.ComponentType<CommonGridInjectedProps>
) as unknown as <T>(props: CommonGridOwnProps<T>) => JSX.Element;

export default CommonGrid;
